import React from 'react';

import { useUser } from '../../hooks/users';
import ToggleHelpButtonFloatingButton from '../Help/ToggleHelpButtonFloatingButton';
import WhatsappFloatingButton from '../Help/WhatsappFloatingButton';

const FloatButtons: React.FC = () => {
  const user = useUser();
  return (
    <>
      <ToggleHelpButtonFloatingButton />
      <WhatsappFloatingButton isAdmin={!!user?.isAdmin} />
    </>
  );
};

export default FloatButtons;
